import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import TableCoreComponent from "../LightTable/TableCoreComponent";
import {Button} from "../Form/Buttons";
import {DateCell, RiskLevel, TextCell} from "../LightTable/Components";
import { groupBy, uniqBy } from 'lodash';
import withPagination from "../LightTable/hoc/Paginated";
import withSort from '../LightTable/hoc/Sortable';
import withFixedHeader from '../LightTable/hoc/withFixedHeader';
import LightTable from "../LightTable/VeryLightTable";
import { compose } from 'redux';
import { SORT } from "../../constants";

const Table = compose(
    withPagination,
    withSort,
    withFixedHeader
)(LightTable);

export default class ArticlesListingTable extends TableCoreComponent {
    static propTypes = {
        //api: PropTypes.object.isRequired,
        headerItems: PropTypes.object,
        onClickArticle: PropTypes.func,
        formatArticleItem: PropTypes.func,
        filters: PropTypes.object
    }

    constructor(props) {
        super(props);

        this.api = props.api;

        const defaultLoadParams = () => ({
            filters: props.filters,
            pagination: { pageNumber: 0, pageSize: 50},
            sorting: { sortBy: "createdDate", direction: SORT.DESC }
        })

        this.loadParams = this.defaultLoadParams = defaultLoadParams();
    }

    getHeaderItems() {
        return [
            { key: "title", label: this.state.totalCount ?
                <ArticlesTitle articleCount={this.state.totalCount} onRefresh={this.handleRefresh}/> : ""},
            { key: "language", label: <FormattedMessage id={"Dashboard_CoreFunctionality_UIText_dashboard.tableHeader.language"}/> },
            { key: "createdDate", label: <FormattedMessage id={"Dashboard_CoreFunctionality_UIText_dashboard.tableHeader.date"}/>, sortable: true },
            { key: "entities", label: <FormattedMessage id={"RSS_Feed_UIText_feedListing.entitiesMentioned"}/> },
            { key: "riskAngleLevel", label: <FormattedMessage id={"Entities_Preview_UIText_previewCompanies.articleView.RiskAngleLevel"}/>}
        ];
    }

    // Overriding formatItem from ArticleListing, data is structured differently for the preview articles
    formatItem(item, searchTerm) {
        let riskLevels = [], riskAngles = [];
        const groupedRisks = groupBy(item.pestleCategories, "name");

        Object.keys(groupedRisks).forEach(risk => {
            riskAngles.push(
                <div className={'risk-row'} key={"risk-angle-" + risk}>
                    <FormattedMessage id={"General_CoreFunctionality_UIText_general." + risk} />
                </div>
            );
            riskLevels.push(
                <div className={'risk-row'} key={"risk-level-" + risk}>
                    {uniqBy(groupedRisks[risk], "scoreLevel").map(riskLevel =>
                        <RiskLevel key={"risk-bullet-"+riskLevel.scoreLevel} risk={
                            {score: riskLevel.scoreLevel, short: riskLevel.scoreLevel[0]}
                        }/>)}
                </div>
            );
        })

        const riskAngleLevels = <div className={'risk-angle-level-wrapper'}>
            {riskAngles.map((angle, index) => <div className={'risk-angle-level-row'} key={angle+index}>{angle}{riskLevels[index]}</div>)}
        </div>
        return {
            title: <ArticleExcerpt title={item.title}
                                   subtitle={item.source}
                                   licensed={item.licensed}
                                   excerpt={item.content}
                                   onClick={this.handleArticleClick(item)}/>,
            language: item.language,
            createdDate: <DateCell timestamp={item.loadDate}/>,
            entityName: item.entityName,
            entities: item.matchedRiskEntityNames ? item.matchedRiskEntityNames.filter(entity => entity).join(', ') : "",
            riskLevel: <Fragment>{riskLevels}</Fragment>,
            riskAngle: <Fragment>{riskAngles}</Fragment>,
            riskAngleLevel: riskAngleLevels,
            object: item
        }
    }

    handleArticleClick = (article) => (e) => {
        const { pageNumber, pageSize } = this.loadParams.pagination;
        const index = pageNumber * pageSize + this.state.listItems.indexOf(article);
        this.props.onClickArticle(article, index);
    }

    getFormattedArticleItems() {
        return this.state.listItems ?
            this.state.listItems.map(item => ({
                ...this.formatItem(item),
                updateFunc: [this.shouldRowUpdate] // inject updateFunc - important for re-render optimization
            })) : null
    }

    getTableProps() {
        return {
            ...super.getTableProps(),
            className: "article-listing-table",
            listItems: this.getFormattedArticleItems(),
            headerItems: this.getHeaderItems(),
            fullScreen: true
        }
    }

    render() {
        return <Table {...this.getTableProps()}/>
    }
}

export const ArticleExcerpt = ({ title, licensed = true, subtitle, excerpt, onClick = () => {}, to = null }) =>
    <div className={"article-excerpt"}>
        { to ? <Link to={to} className={"title"}>{title}</Link> : <div className={"title"} onClick={onClick}>{title}</div>}
        <div className={"subtitle"}>{subtitle} {!licensed && <span className="la-ExternalLink article-icon" />} </div>
        <div className={"content"}>{excerpt} ...</div>
    </div>;

export const ArticlesTitle = ({ refreshLabel = "Refresh", onRefresh, articleCount, filterCount = articleCount }) =>
    <div className={"table-control-refresh"}>
        {articleCount !== filterCount ?
            <FormattedMessage id={"General_CoreFunctionality_UIText_countBox.showTotal"}
                              values={{resultsCount: articleCount, filterCount: filterCount}}/> :
            <FormattedMessage id={"General_CoreFunctionality_UIText_countBox.showTotal"}
                              values={{resultsCount: articleCount}}/>
        }
        {onRefresh && <Button action={onRefresh}>{refreshLabel}</Button>}
    </div>


// WEBPACK FOOTER //
// ./src/scripts/reusable/Articles/ArticlesListingTable.jsx